import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"dashboard-card",class:{ expanded: _vm.expanded },attrs:{"disabled":_vm.disabled,"color":"surface lighten-1","elevation":"3"}},[_c(VBtn,{staticClass:"expand-toggle",attrs:{"icon":""},on:{"click":function($event){_vm.expanded = !_vm.expanded}}},[(_vm.expanded)?_c(VIcon,[_vm._v("mdi-arrow-collapse")]):_c(VIcon,[_vm._v("mdi-arrow-expand")])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }